import { useRef, useState } from "react"
import { BsEnvelopeFill } from "react-icons/bs"
import { FaTicket } from "react-icons/fa6"
import { IoIosArrowForward } from "react-icons/io"
import { MdCancelPresentation } from "react-icons/md"
import { RiText } from "react-icons/ri"
import { useNavigate } from "react-router-dom"

import { useAlert } from "@fuse/sharedComponents/globalAlert"
import ReachOutComponent from "@fuse/sharedComponents/ReachOutComponent"
import { showErrorToast } from "@fuse/sharedComponents/themeToast/toastUtils"
import { EFeatureFlags } from "@letshang/constants"
import { isEmpty } from "lodash-es"
import { useRecoilValue } from "recoil"
import { ROUTES } from "src/App"

import { userState } from "@fuse/recoil/signup"

import { useProcessFeatureFlags } from "@settingsAlias/featureFlags"

import { DownloadAppModalHandle } from "@fuse/pages/landingPage/components/DownloadAppModal"

const MoreComponentv3 = ({
  eventId,
  onTicketsClick,
  isDefaultBg,
  onOpenDownloadAppModal,
}: {
  eventId: string
  onTicketsClick: () => void
  isDefaultBg: boolean
  onOpenDownloadAppModal: () => void
}) => {
  //   const modalRef = useRef<DownloadAppModalHandle>(null)
  //   const onOpenDownloadAppModal = () => {
  //     modalRef.current?.openModal()
  //   }
  const user = useRecoilValue(userState)
  const [isLoading, setIsLoading] = useState(false)

  const { showAlert } = useAlert()
  const navigate = useNavigate()

  const handleTicketsClick = () => {
    // if (isEmpty(eventId)) {
    //   showErrorToast("Please fill the event information first")
    //   return
    // }
    onTicketsClick()
  }

  const onOpenCancelEventModal = () => {
    showAlert(
      "Are you sure you want to cancel this event?",
      "If you cancel now, all the progress you’ve made on this event will be lost.",
      "Cancel event",
      () => {
        navigate(ROUTES.LANDING)
      },
      "Cancel",
      () => {},
    )
  }

  const userLevelTicketedEventsWebFeatureFlag = useProcessFeatureFlags(
    EFeatureFlags.TICKETED_EVENTS_WEB,
  )

  return (
    <div className="w-full mt-4">
      <div className="flex flex-col w-full">
        <div className="flex flex-col gap-4 w-full ">
          <p className="text-white font-semibold text-lg text-left ">
            Registration
          </p>
          <div
            className={`flex flex-row gap-4 items-center ${
              isDefaultBg ? "bg-black/50" : "bg-white/10"
            } rounded-2xl p-4 w-full cursor-pointer `}
            onClick={
              //   userLevelTicketedEventsWebFeatureFlag
              //     ? handleTicketsClick
              // :
              onOpenDownloadAppModal
            }
          >
            <FaTicket className="text-white/30 text-lg" />
            <div className="flex flex-row gap-4 items-center flex-1">
              <span className="text-white/30 text-lg">Tickets</span>
            </div>
            <IoIosArrowForward className="text-white/30 text-lg" />
          </div>
        </div>
        <div className="mt-8 flex flex-col gap-4">
          <p className="text-left text-lg font-semibold text-white">
            Communication
          </p>
          <div
            className={`flex flex-col gap-4 items-center ${
              isDefaultBg ? "bg-black/50 " : "bg-white/10"
            } rounded-2xl p-4 w-full `}
          >
            <div className="flex flex-row gap-4 items-center rounded-2xl w-full">
              <RiText className="text-white/60 text-lg" />
              <div className="flex flex-row gap-4 items-center flex-1">
                <ReachOutComponent
                  eventId={eventId}
                  featureName="text-blasts"
                  defaultMessage="Hi, I'd like assistance with sending text message updates to my event attendees. Could you help me set up text blasts?"
                  buttonText="Text blasts"
                  title="Need Help with Text Blasts?"
                  description="Our team will help you set up automated text messaging for your event."
                  className="text-white text-left w-full bg-transparent border-none p-0 hover:text-white/80"
                  isInline={true}
                />
              </div>
            </div>
            <hr className="w-full border-white/20" />
            <div className="flex flex-row gap-4 items-center rounded-2xl w-full">
              <BsEnvelopeFill className="text-white/60 text-lg" />
              <div className="flex flex-row gap-4 items-center flex-1">
                <ReachOutComponent
                  eventId={eventId}
                  featureName="guest-invitations"
                  defaultMessage="Hi, I'd like assistance with inviting guests to my event and managing invitations. Could you help me set up guest invitation features?"
                  buttonText="Invite"
                  title="Need Help with Invitations?"
                  description="Our team will help you set up guest invitation and management features."
                  className="text-white text-left w-full bg-transparent border-none p-0 hover:text-white/80"
                  isInline={true}
                />
              </div>
            </div>
            <hr className="w-full border-white/20" />
            <div
              className="flex flex-row gap-4 items-center rounded-2xl w-full cursor-pointer"
              onClick={onOpenCancelEventModal}
            >
              <MdCancelPresentation className="text-[#FF6E6E] text-lg" />
              <div className="flex flex-row gap-4 items-center flex-1">
                <span className="text-[#FF6E6E] text-lg">Cancel Event</span>
              </div>
              <IoIosArrowForward className="text-[#FF6E6E] text-lg" />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MoreComponentv3
